<template>
  <div class="jumbotron no_space">
    <div class="container bg-pie">

      <aside
        id="text-3"
        class="widget widget_text"
      >
        <div class="textwidget">
          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <h3><img
                src="../../assets/logoPie.jpg"
                alt="Logotipo"
                class="center-block"
              ></h3>
            <p class="text-center footer"><a href="mailto:info@kutxabank.es&#10;">info@kutxabank.es</a> | <a
                :href="legalUrl"
                target="_blank"
                title="El enlace se abrirá en una ventana nueva"
              >{{$t('Aviso Legal')}}</a> | <a
                :href="condicionesUrl"
                target="_blank"
                title="El enlace se abrirá en una ventana nueva"
              >{{$t('Condiciones Generales')}}</a> | <a :href="privacidadUrl" target="_blank" rel="noopener noreferrer">{{$t('Privacidad')}}</a> | <a :href="cookieUrl" target="_blank" rel="noopener noreferrer"><span class="white--text">{{$t('Uso de cookies')}} </span> </a>
              <!-- <router-link :to="`/${$i18n.locale}/pag/privacidad`">{{$t('Privacidad')}}</router-link> -->
              | <span style="
                    text-align: center;
                    color: white;
                    font-size: 80%;
                    font-weight: bold;
                    font-family: Arial, Geneva, sans-serif;
                ">© Kutxabank</span></p>
            <ul id="m_pie">
              <li></li>
            </ul>
          </div>
        </div>
      </aside>
    </div>
        <footer>
      <!-- <cookie-law theme="blood-orange">
        <div slot-scope="props">

          <v-layout
            row
            class="pa-2"
            wrap
          >
            <v-flex
              xs12
              md9
              offset-md1
            >
              <h3 class="body-1 mt-0">{{$t('Uso de cookies')}}</h3>
              <p class="white--text caption">
                {{$t('texto cookies')}} 
              </p>
              
              
            </v-flex>
            
            <v-flex
              xs12
              md1
              class="pt-4"
            >
              <v-btn
                color="red"
                dark
                class="skew"
                @click="props.accept"
              ><span>{{$t('Aceptar')}}</span></v-btn>
            </v-flex>
          </v-layout>
        </div>
      </cookie-law> -->
    </footer>
  </div>
</template>
<style>
.Cookie--blood-orange .layout.row {
  width: 100vw;
}
</style>

<script>
import CookieLaw from "vue-cookie-law";
export default {
  mounted() {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  },
  components: { CookieLaw },
  computed: {
    privacidadUrl() {
      const privacidadUrls = {
        eu:
          "https://portal.kutxabank.es/cs/Satellite/kb/eu/pribatutasuna/generico",
        es:
          "https://portal.kutxabank.es/cs/Satellite/kb/es/privacidad/generico",
        en:
          "https://portal.kutxabank.es/cs/Satellite/kb/es/privacidad/generico",
        fr:
          "https://portal.kutxabank.es/cs/Satellite/kb/es/privacidad/generico",
      };

      const lang = this.$i18n.locale;
      return privacidadUrls[lang];
    },
    legalUrl() {
      const legalUrls = {
        eu:
          "https://portal.kutxabank.es/cs/Satellite/kb/eu/legeoharra/generico",
        es:
          "https://portal.kutxabank.es/cs/Satellite/kb/es/aviso-legal-0/generico",
        en:
          "https://portal.kutxabank.es/cs/Satellite/kb/es/aviso-legal-0/generico",
        fr:
          "https://portal.kutxabank.es/cs/Satellite/kb/es/aviso-legal-0/generico",
      };

      const lang = this.$i18n.locale;
      return legalUrls[lang];
    },
    condicionesUrl() {
      const condicionesUrls = {
        eu:
          "https://ticket.kutxabank.es/static/web/html/EU/condicionesGenerales.html",
        es:
          "https://ticket.kutxabank.es/static/web/html/ES/condicionesGenerales.html",
        en:
          "https://ticket.kutxabank.es/static/web/html/EN/condicionesGenerales.html",
        fr:
          "https://ticket.kutxabank.es/static/web/html/FR/condicionesGenerales.html",
      };

      const lang = this.$i18n.locale;
      return condicionesUrls[lang];
    },
    cookieUrl() {
      const cookieUrls = {
        eu:
          "https://portal.kutxabank.es/cs/Satellite/kb/eu/partikularrak/segurtasuna_0/cookien_politika/generico",
        es:
          "https://portal.kutxabank.es/cs/Satellite/kb/es/politica_de_cookies/generico",
        en:
          "https://portal.kutxabank.es/cs/Satellite/kb/en/private_customers/security_0/cookies_policy/generico",
        fr:
          "https://portal.kutxabank.es/cs/Satellite/kb/en/private_customers/security_0/cookies_policy/generico",
      };
      const lang = this.$i18n.locale;
      return cookieUrls[lang];
    },
  },
};
</script>
